import React, { useState } from 'react';
import './RateAppPage.css';

function RateAppPage() {
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleRating = (stars) => {
    setRating(stars);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating === 0) {
      alert('Please select a rating');
      return;
    }
    // Here you would typically send the rating to your backend
    setSubmitted(true);
    
    setTimeout(() => {
      setSubmitted(false);
      setRating(0);
      setReview('');
    }, 3000);
  };

  return (
    <div className="rate-app-page">
      <div className="container">
        <div className="page-header">
          <h2>Rate Our App</h2>
          <p>We value your feedback</p>
        </div>

        {submitted ? (
          <div className="thank-you">
            <div className="thank-you-icon">❤️</div>
            <h3>Thank You!</h3>
            <p>Your feedback has been submitted successfully.</p>
          </div>
        ) : (
          <form className="rating-form" onSubmit={handleSubmit}>
            <div className="rating-section">
              <h3>How would you rate your experience?</h3>
              <div className="stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    className={`star ${star <= rating ? 'active' : ''}`}
                    onClick={() => handleRating(star)}
                  >
                    ★
                  </button>
                ))}
              </div>
              <p className="rating-text">
                {rating === 0 ? 'Select a rating' : 
                 rating === 1 ? 'Poor' :
                 rating === 2 ? 'Fair' :
                 rating === 3 ? 'Good' :
                 rating === 4 ? 'Very Good' : 'Excellent'}
              </p>
            </div>

            <div className="form-group">
              <label>Tell us more (optional)</label>
              <textarea
                value={review}
                onChange={(e) => setReview(e.target.value)}
                placeholder="What did you like or what can we improve?"
                rows="4"
              />
            </div>

            <button type="submit" className="submit-btn">
              Submit Review
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default RateAppPage;